<template>
  <div class="app-container">
    <div class="fixed-scale-control">
      <el-slider v-model="scaleFactor" height="200px" :min="0.5" :max="1.5" :step="0.1" :format-tooltip="formatTooltip" @change="handleScaleChange" class="scale-slider"></el-slider>
      <span class="scale-value">{{ formatScaleValue }}</span>
    </div>

    <div class="topo-wrap" v-loading="loading" ref="topoWrap">
      <div class="topo-item" v-for="(topoItem, topoIndex) in topoData" :key="`topo-${topoIndex}`">
        <div class="top-line-name">{{ topoItem.label }}</div>

        <svg
          :ref="`svg${topoIndex}`"
          v-if="topoItem.devices && topoItem.devices.length"
          class="topo"
          :style="{
            width: topoItem.svgWidth + 100 + 'px',
            height: topoItem.svgHeight - 10 + 'px',
            transform: `translate(-90px, -66px) scale(${scaleFactor})`,
            transition: 'transform 0.5s ease'
          }"
          ondragover="return false"
          oncontextmenu="return true"
        >
          <!-- 连接的线 -->
          <line v-for="(relation, index) in topoItem.relation" :key="`line-${topoIndex}-${index}`" :x1="relation.x1" :y1="relation.y1" :x2="relation.x2" :y2="relation.y2" v-if="isRelationVisible(relation, topoItem)" style="stroke: rgb(0, 210, 0); stroke-width: 2" />

          <!-- 左边固定图例start -->
          <!-- <line x1="20" y1="200" x2="70" y2="200" style="stroke: rgb(0, 210, 0); stroke-width: 2" />
          <line x1="90" y1="200" :x2="firstDeviceX(topoItem)" :y2="firstDeviceY(topoItem)" style="stroke: rgb(0, 210, 0); stroke-width: 2" /> -->

          <text style="fill: #fff" x="20" y="90">
            {{ topoItem.label }}
          </text>

          <!-- 变电站垂直线 -->
          <!-- <line x1="20" y1="100" x2="20" y2="300" style="stroke: rgb(0, 210, 0); stroke-width: 3" /> -->

          <text style="fill: #fff" x="40" y="185">
            {{ topoItem.label }}
          </text>
          <!-- <rect width="20" height="10" fill="#FE0000" x="70" y="195" /> -->
          <!-- 左边固定图例end -->

          <g v-for="(item, deviceIndex) in topoItem.devices" :key="`device-${topoIndex}-${deviceIndex}`" v-if="item.visible">
            <!-- 设备图标 -->
            <image
              v-if="item.type !== '拐点'"
              class="indicator"
              :xlink:href="getDeviceImageUrl(item.type)"
              width="45px"
              height="45px"
              :x="item.x - 24"
              :y="item.y - 28"
              @mousemove="handleMouseMove"
              @mouseenter="handleBlur(item, 1)"
              @mouseleave="handleBlur(item, 2)"
              @blur="handleBlur(item, 3)"
              @click="toggleDeviceVisibility(item.id)"
              @dblclick="onClickImgItem(item)"
            >
              <!-- <title v-html="getDeviceTooltip(item)"></title> -->
            </image>

            <!-- 塔架或分支点 -->
            <circle v-if="item.type == 'tower' || item.type == 'branch'" class="tower" :cx="item.x" :cy="item.y" r="8" :fill="item.type == 'tower' ? '#fff' : '#00CD00'" @click="toggleDeviceVisibility(item.id)" />

            <!-- 设备信息（总是显示） -->
            <g class="device-info">
              <!-- 设备标签 -->
              <text v-if="item.label" :x="item.x" :y="item.y + 35" style="text-anchor: middle; user-select: none; fill: #fff; font-size: 12px">
                <tspan v-if="item.dev_type != 6" style="font-size: 12px">
                  <tspan :x="item.x + 17" :y="item.y - 5" text-anchor="start">
                    {{ item.label }}
                  </tspan>
                </tspan>
                <tspan v-if="item.short_tips" :x="item.x" :y="item.y + 30">
                  <tspan style="fill: rgb(255, 0, 0); font-size: 12px">
                    {{ item.short_tips }}
                  </tspan>
                </tspan>
              </text>
              <!-- 折叠状态指示器：+号（只有在有子级且处于折叠状态时才显示） -->
              <circle v-if="shouldShowPlusIcon(item.id)" :cx="item.x - 0.7" :cy="item.y + 28" r="7" :fill="'rgba(0, 0, 0, 0.3)'" :stroke="'#fff'" stroke-width="2" />
              <text v-if="shouldShowPlusIcon(item.id)" :x="item.x - 1" :y="item.y + 32.5" style="text-anchor: middle; fill: #fff; font-size: 14px; font-weight: bold">+</text>
              <!-- 功率信息（根据您的图片） -->
              <text v-if="getPowerInfo(item)" :x="item.x" :y="item.y + 65" style="text-anchor: middle; fill: #00ff00; font-size: 11px">
                {{ getPowerInfo(item) }}
              </text>
            </g>
          </g>
        </svg>

        <div v-else class="no-data">{{ $t("topovue.nodata") }}</div>

        <div class="tooltip" :class="{ hidden: isVisible }" :style="dynamicStyle">
          <div class="d_item" v-if="sel_item.name">
            <label class="lb_1">名称：</label><label class="lb_2">{{ sel_item.name }}</label>
          </div>
          <div class="d_item">
            <label class="lb_1">名称：</label><label class="lb_2">{{ sel_item.label }}</label>
          </div>
          <div class="d_item" v-if="sel_item.assets_code">
            <label class="lb_1">资产码：</label><label class="lb_2">{{ sel_item.assets_code }}</label>
          </div>
          <div class="d_item" v-if="sel_item.branch_box_gun_no">
            <label class="lb_1">通道：</label><label class="lb_2">{{ sel_item.branch_box_gun_no }}</label>
          </div>
          <div class="d_item" v-if="sel_item.fee_table_address">
            <label class="lb_1">电表地址：</label><label class="lb_2">{{ sel_item.fee_table_address }}</label>
          </div>
          <div class="d_item">
            <label class="lb_1">类型：</label><label class="lb_2">{{ sel_item.type }}</label>
          </div>
          <div class="d_item" v-if="sel_item.acVal">
            <label class="lb_1">电流：</label><label class="lb_2">{{ sel_item.acVal }}A</label>
          </div>
          <!-- <div  class="d_item" v-if="sel_item.tips">
            <label class="lb_1">状态：</label><label class="lb_2">
              {{ sel_item.tips }}</label>
          </div> -->
          <div class="d_item" v-if="sel_item.plat_form">
            <label class="lb_1">状态：</label
            ><label class="lb_2">
              <table class="tp-table" cellpadding="0" cellspacing="0">
                <tr>
                  <th>相别</th>
                  <th>功率</th>
                  <th>电压</th>
                  <th>电流</th>
                  <th>温度</th>
                </tr>
                <tr>
                  <td>A相</td>
                  <td>{{ sel_item.plat_form.realAPower / 100 }}kW</td>
                  <td>{{ sel_item.plat_form.acVolA / 10 }}V</td>
                  <td>{{ sel_item.plat_form.acCurA / 100 }}A</td>
                  <td v-if="sel_item.plat_form.tempA < 0" style="text-align: center">--</td>
                  <td v-else>{{ sel_item.plat_form.tempA / 100 }}℃‌</td>
                </tr>
                <tr>
                  <td>B相</td>
                  <td>{{ sel_item.plat_form.realBPower / 100 }}kW</td>
                  <td>{{ sel_item.plat_form.acVolB / 10 }}V</td>
                  <td>{{ sel_item.plat_form.acCurB / 100 }}A</td>
                  <td v-if="sel_item.plat_form.tempB < 0" style="text-align: center">--</td>
                  <td v-else>{{ sel_item.plat_form.tempB / 100 }}℃‌</td>
                </tr>
                <tr>
                  <td>C相</td>
                  <td>{{ sel_item.plat_form.realCPower / 100 }}kW</td>
                  <td>{{ sel_item.plat_form.acVolC / 10 }}V</td>
                  <td>{{ sel_item.plat_form.acCurC / 100 }}A</td>
                  <td v-if="sel_item.plat_form.tempC < 0" style="text-align: center">--</td>
                  <td v-else>{{ sel_item.plat_form.tempC / 100 }}℃‌</td>
                </tr>
              </table></label
            >
          </div>

          <div class="d_item" v-if="sel_item.ac_data">
            <label class="lb_1">状态：</label
            ><label class="lb_2">
              <table class="tp-table" cellpadding="0" cellspacing="0">
                <tr>
                  <th>功率</th>
                  <th>电压</th>
                  <th>电流</th>
                  <th>温度</th>
                </tr>
                <tr>
                  <td>{{ sel_item.ac_data.realPower / 100 }}kW</td>
                  <td>{{ sel_item.ac_data.acVolA / 10 }}V</td>
                  <td>{{ sel_item.ac_data.acCurA / 100 }}A</td>
                  <td>{{ sel_item.ac_data.acVolB / 100 }}℃‌</td>
                </tr>
              </table></label
            >
          </div>
          <div class="d_item" v-if="sel_item.ac_data">
            <label class="lb_1">采集时间：</label><label class="lb_2">{{ sel_item.ac_data.create_time }}</label>
          </div>
          <div class="d_item" v-if="sel_item.plat_form">
            <label class="lb_1">采集时间：</label><label class="lb_2">{{ sel_item.plat_form.create_time }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { GetTransformerTree, AnalyzingFaultByGround } from "@/api/dev_archive"

export default {
  data() {
    return {
      loading: false,
      scaleFactor: 1,
      topoData: [],
      mouse_x: 0,
      mouse_y: 0,
      dynamicStyle: {
        left: "0px",
        fontSize: "14px", // 直接使用字符串
        marginTop: "10px" // 直接使用字符串
        // 可以直接使用数字，例如：marginTop: 10, Vue会自动转换为'10px'
      },
      isVisible: false,
      sel_item: {},
      imageCache: {},
      // 防止重复点击
      isProcessing: false,
      // 记录每个节点的折叠状态
      collapsedStates: {}
    }
  },
  props: {
    RecordID: 0,
    SubstationID: 0,
    faultInfo: {
      archive_name: "",
      fault_time: "",
      fault_term: "",
      fault_type: ""
    }
  },
  computed: {
    formatScaleValue() {
      if (this.scaleFactor == null || isNaN(this.scaleFactor)) {
        return "1.0"
      }
      return Number(this.scaleFactor).toFixed(1)
    }
  },
  watch: {
    RecordID(val) {
      this.getData()
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleMouseMove(event) {
      console.log("event", window.innerHeight)
      this.mouse_x = event.layerX // 鼠标的X坐标（相对于视口）
      //this.mouse_y = window.innerHeight - event.layerY // 鼠标的Y坐标（相对于视口）
      this.mouse_y = event.layerY
      this.reSetDynamicStyle()
    },
    handleBlur(item, type) {
      this.sel_item = item
      this.isVisible = type == 1
      this.reSetDynamicStyle()
      // 可在此处添加验证、保存等逻辑
    },
    reSetDynamicStyle() {
      this.dynamicStyle.left = this.mouse_x + 40 + "px"
      //this.dynamicStyle.bottom=(this.mouse_y-270)+"px";
      this.dynamicStyle.top = this.mouse_y - 10 + "px"
    },
    // 获取设备图片URL
    getDeviceImageUrl(type) {
      if (!type) return require("@/assets/拐点.png")

      if (this.imageCache[type]) {
        return this.imageCache[type]
      }

      try {
        const imageUrl = require(`@/assets/${type}.png`)
        this.imageCache[type] = imageUrl
        return imageUrl
      } catch (error) {
        console.warn(`图片 ${type}.png 加载失败，使用默认图片`)
        return require("@/assets/拐点.png")
      }
    },

    // 获取功率信息
    getPowerInfo(item) {
      if (item.power_info) return item.power_info

      // 根据您的图片，为特定设备添加功率信息
      // if (item.label) {
      //   if (item.label.includes('曹工研发') || item.label.includes('费工研发')) {
      //     return "A: 28kW,B: 0kW,C: 0kW"
      //   } else if (item.label.includes('研发测试分支箱')) {
      //     return "A: 28KW,B: 0KW,C: OKW"
      //   } else if (item.label.includes('测试研发')) {
      //     return "A: 0KW,B: 0KW,C: OKW"
      //   }
      // }
      return null
    },

    // 获取设备提示信息 充电站 = 0,台区 = 1,一体柜 = 2,分支箱 = 3,充电桩 = 4,充电枪 = 5,拐点 = 6
    getDeviceTooltip(item) {
      const parts = []
      if (item.name) parts.push(`名称： ${item.name}`)
      if (item.label) parts.push(`标签： ${item.label}`)
      if (item.type) parts.push(`类型： ${item.type}`)
      if (item.acVal) parts.push(`电流：${item.acVal}A`)
      if (item.tips) parts.push(`状态：${item.tips}`)
      if (item.dev_type != 0) parts.push(`资产码：${item.assets_code ? item.assets_code : "无"}`)
      if (item.dev_type == 4) parts.push(`通道：${item.branch_box_gun_no ? item.branch_box_gun_no : "未绑定"}`)

      if (item.ac_data) parts.push(`数据时间：${item.ac_data.create_time}`)
      if (item.plat_form) parts.push(`数据时间：${item.plat_form.create_time}`)

      return parts.join("\n")
    },

    // 获取第一个可见设备的X坐标
    firstDeviceX(topoItem) {
      if (!topoItem.devices || !topoItem.devices.length) return 150
      const firstVisible = topoItem.devices.find((d) => d && d.visible !== false)
      return firstVisible ? firstVisible.x : 150
    },

    // 获取第一个可见设备的Y坐标
    firstDeviceY(topoItem) {
      if (!topoItem.devices || !topoItem.devices.length) return 200
      const firstVisible = topoItem.devices.find((d) => d && d.visible !== false)
      return firstVisible ? firstVisible.y : 200
    },

    formatTooltip(val) {
      if (val == null || isNaN(val)) {
        return "1.0"
      }
      return Number(val).toFixed(1)
    },

    onClickImg(item, lineName) {
      const url = this.$router.resolve({
        path: "/fault/fault-waveform",
        query: { ID: item.label.Ic, name: item.name, lineName: lineName }
      }).href
      window.open(url, "_blank")
    },

    onClickImgItem(item) {
      const url = this.$router.resolve({
        path: "/fault/fault-waveform",
        query: { dev_id: item.id, time: this.faultInfo.fault_time, name: item.name }
      }).href
      window.open(url, "_blank")
    },

    handleScaleChange(value) {
      this.scaleFactor = value
    },

    // 判断设备是否有子级
    hasChildren(deviceId) {
      const topoItem = this.topoData[0]
      if (!topoItem || !topoItem.relation) return false

      // 检查是否有以deviceId为源的关系
      return topoItem.relation.some((relation) => relation && relation.source === deviceId)
    },

    // 判断是否显示+号图标
    // 只有在设备有子级且处于折叠状态时才显示
    shouldShowPlusIcon(deviceId) {
      return this.hasChildren(deviceId) && this.collapsedStates[deviceId] === true
    },

    // 切换设备可见性 - 带记忆的折叠/展开功能
    toggleDeviceVisibility(deviceId) {
      if (this.isProcessing) {
        console.log("正在处理中，请稍后...")
        return
      }

      this.isProcessing = true

      const topoItem = this.topoData[0]
      if (!topoItem || !topoItem.relation) {
        this.isProcessing = false
        return
      }

      // 查找目标设备
      const targetDevice = topoItem.devices.find((dev) => dev && dev.id === deviceId)
      if (!targetDevice) {
        this.isProcessing = false
        return
      }

      // 获取目标节点的所有下级节点（不包括当前节点）
      const getAllChildren = (parentId) => {
        const children = []
        const queue = [parentId]
        const visited = new Set()

        while (queue.length > 0) {
          const currentId = queue.shift()
          visited.add(currentId)

          // 找到所有以currentId为源的子设备
          const directChildren = topoItem.relation.filter((rel) => rel && rel.source === currentId).map((rel) => rel.target)

          directChildren.forEach((childId) => {
            if (!visited.has(childId)) {
              visited.add(childId)
              queue.push(childId)
              children.push(childId)
            }
          })
        }

        return children
      }

      // 获取所有下级节点（不包括当前节点）
      const allChildren = getAllChildren(deviceId)

      console.log(`点击设备 ${deviceId}，下级节点数量: ${allChildren.length}`)

      // 即使没有下级节点，也要设置折叠状态，以便记录点击状态
      if (this.collapsedStates[deviceId] === undefined) {
        this.collapsedStates[deviceId] = false // 默认展开状态
      }

      // 切换折叠状态
      this.collapsedStates[deviceId] = !this.collapsedStates[deviceId]
      const newVisibility = !this.collapsedStates[deviceId] // false表示折叠(隐藏), true表示展开(显示)

      console.log(`切换折叠状态: ${this.collapsedStates[deviceId] ? "折叠(隐藏)" : "展开(显示)"}`)

      // 将下级节点的折叠状态重置为false（展开状态）
      allChildren.forEach((childId) => {
        this.collapsedStates[childId] = false
      })

      // 根据折叠状态切换所有下级节点的可见性
      allChildren.forEach((childId) => {
        const childDevice = topoItem.devices.find((dev) => dev && dev.id === childId)
        if (childDevice) {
          this.$set(childDevice, "visible", newVisibility)
        }
      })

      // 强制视图更新
      this.$nextTick(() => {
        this.$forceUpdate()
        this.isProcessing = false
      })
    },

    // 判断连接线是否可见
    isRelationVisible(relation, topoItem) {
      if (!relation || !topoItem || !topoItem.devices) return false

      const sourceDevice = topoItem.devices.find((dev) => dev && dev.id === relation.source)
      const targetDevice = topoItem.devices.find((dev) => dev && dev.id === relation.target)

      if (!sourceDevice || !targetDevice) return false

      return sourceDevice.visible !== false && targetDevice.visible !== false
    },

    getData() {
      this.loading = true
      GetTransformerTree({
        powersiteid: this.RecordID
      })
        .then((res) => {
          if (res.data) {
            const OFFSET = 0
            let topoWrap = this.$refs.topoWrap

            this.topoData = []
            this.collapsedStates = {} // 重置折叠状态

            this.$nextTick(() => {
              let topoData = [res.data]

              topoData.forEach((topoItem) => {
                let hash = {}
                if (topoItem.devices && topoItem.devices.length) {
                  let maxValX = 0
                  let maxValY = 0

                  if (topoItem.devices[0]) {
                    maxValX = topoItem.devices[0].x || 0
                    maxValY = topoItem.devices[0].y || 0
                  }

                  // 初始化设备可见性和计算最大坐标
                  topoItem.devices.forEach((item, index) => {
                    if (!item) return

                    hash[item.id] = index

                    // 初始化可见性
                    this.$set(topoItem.devices[index], "visible", true)

                    // 更新最大坐标
                    if (item.x > maxValX) {
                      maxValX = item.x
                    }
                    if (item.y > maxValY) {
                      maxValY = item.y
                    }
                  })

                  // 设置SVG尺寸
                  const containerWidth = topoWrap ? topoWrap.clientWidth : window.innerWidth
                  topoItem.svgWidth = maxValX < containerWidth ? containerWidth + "px" : maxValX + 50
                  topoItem.svgHeight = maxValY + 450

                  // 计算连接线坐标
                  if (topoItem.relation) {
                    topoItem.relation = topoItem.relation
                      .map((item) => {
                        if (!item) return null

                        const startNode = topoItem.devices[hash[item.source]]
                        const endNode = topoItem.devices[hash[item.target]]

                        if (startNode && endNode) {
                          return {
                            x1: startNode.x + OFFSET,
                            y1: startNode.y + OFFSET,
                            x2: endNode.x + OFFSET,
                            y2: endNode.y + OFFSET,
                            source: item.source,
                            target: item.target
                          }
                        } else if (startNode) {
                          return {
                            x1: startNode.x + OFFSET,
                            y1: startNode.y + OFFSET,
                            x2: OFFSET,
                            y2: OFFSET,
                            source: item.source,
                            target: item.target
                          }
                        }
                        return null
                      })
                      .filter((item) => item !== null)
                  }
                } else {
                  topoItem.svgWidth = "100%"
                  topoItem.svgHeight = 500
                }
              })

              this.topoData = topoData
            })
          } else {
            this.topoData = []
          }
        })
        .catch((error) => {
          console.error("获取拓扑数据失败:", error)
          this.topoData = []
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  position: relative;
  height: 100%;
  min-height: 500px;
}

.topo-wrap {
  padding: 20px;
  background-color: #000000;
  overflow: auto;
  height: calc(100vh - 120px);
  position: relative;
  min-height: 400px;
  border: 1px solid #333;

  .topo-item {
    position: relative;
    min-height: 300px;
  }

  .top-line-name {
    color: #fff;
    font-size: 28px;
    text-align: center;
    margin-top: 16px;
    margin-bottom: 20px;
  }
}

.fixed-scale-control {
  position: absolute;
  right: 45px;
  top: 22px;
  z-index: 1000;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 10px 15px;
  border-radius: 4px;
  min-width: 200px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}

.scale-slider {
  width: 150px;
  margin-right: 15px;
}

.scale-value {
  color: #fff;
  font-size: 14px;
  min-width: 30px;
  text-align: center;
  font-weight: bold;
  font-family: "Courier New", monospace;
}

.topo {
  width: 100%;
  height: 100%;
  background-color: #000000;
  display: block;
  overflow: visible;
}

.indicator {
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }
}

.tower {
  cursor: pointer;
  transition: r 0.3s ease;

  &:hover {
    r: 10;
  }
}

.device-info {
  pointer-events: none;
}

.no-data {
  text-align: center;
  color: #fff;
  font-size: 24px;
  line-height: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 自定义el-slider样式为黑色主题 */
::v-deep .el-slider__runway {
  background-color: #333;
}

::v-deep .el-slider__bar {
  background-color: #666;
}

::v-deep .el-slider__button {
  border-color: #999;
  background-color: #000;
  width: 12px;
  height: 12px;
  transition: all 0.2s ease;
}

::v-deep .el-slider__button:hover {
  border-color: #fff;
  transform: scale(1.2);
}

::v-deep .el-slider__stop {
  background-color: #555;
}

/* 自定义滚动条样式 */
.topo-wrap::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.topo-wrap::-webkit-scrollbar-track {
  background: #000000;
  border-radius: 5px;
}

.topo-wrap::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 5px;
  border: 2px solid #1a1a1a;
}

.topo-wrap::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.topo-wrap::-webkit-scrollbar-corner {
  background: #000000;
}
</style>
<style lang="scss">
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  visibility: hidden;
  min-width: 120px;
  background-color: rgb(240, 238, 238);
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;

  /* 添加过渡效果 */
  opacity: 0.8;
  transition: opacity 0.3s;
  .d_item {
    line-height: 26px;
    width: 420px;
    display: flex;
    .lb_1 {
      width: 90px;
      text-align: right;
    }
    .lb_2 {
      text-align: left;
      flex: 2;
    }
  }
  .tp-table {
    border: 1px solid #999;
    th,
    td {
      border-bottom: 1px solid #999;
      border-right: 1px solid #999;
      padding: 0px 6px;
    }
    border-bottom: 0px solid #999;
    border-right: 0px solid #999;
    td {
      font-weight: normal;
    }
  }
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.hidden {
  visibility: visible;
}
</style>
